import ActivityDetailsText from "@/modules/lead-page/new/components/activity/activity-details-typography";
import UserNameTag from "@/modules/lead-page/new/components/activity/user-name-tag";
import { useTheme } from "@mui/material";
import { Stack } from "@mui/material";

interface CommentDetailsProps {
  actorName?: string | null;
  actorColor?: string | null;
  actionText?: string;
}

const CommentDetails = ({ actorName, actorColor, actionText = "added a comment" }: CommentDetailsProps) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={theme.nawy.spacing.xxs}
      alignItems="center"
      flexWrap="wrap"
    >
      {actorName && (
        <>
          <UserNameTag name={actorName} color={actorColor} />
          <ActivityDetailsText>{actionText}</ActivityDetailsText>
        </>
      )}
    </Stack>
  );
};

export default CommentDetails;
